import React, { memo } from "react";
import PropTypes from "prop-types";
import Row from "../../../Common/Row";
import Table from "../../../Common/Table";

const Rows = memo(({ customer }) => {
	const termsAccepted = customer.hasAcceptedTerms ? `Yes` : `No`,
		emailVerified = customer.hasVerifiedEmail ? `Yes` : `No`;
	return (
		<>
			<Row label={`Terms accepted`} value={termsAccepted} />
			<Row label={`Email verified`} value={emailVerified} />
			<Row label={`Toyota ID`} value={customer.toyotaID} />
			<Row label={`Title`} value={customer.title} />
			<Row label={`First name`} value={customer.firstName} />
			<Row label={`Last name`} value={customer.lastName} />
			<Row label={`E-mail`} value={customer.email} />
			<Row label={`Username`} value={customer.userName} />
		</>
	);
});

const PersonalDetails = memo(({ customer }) => {
	const { icon, status } = customer.hasAcceptedTerms
		? { icon: `glyphicon glyphicon-ok`, status: `active` }
		: { icon: `glyphicon glyphicon-remove`, status: `inactive` };
	return (
		<Table
			title={`Personal details`}
			icon={icon}
			colorClass={`customer-${status}`}
			iconHoverText={`Customer is ${status}`}
		>
			<Rows customer={customer} />
		</Table>
	);
});
PersonalDetails.displayName = `PersonalDetails`;
PersonalDetails.propTypes = {
	customer: PropTypes.object.isRequired
};
Rows.displayName = `Rows`;
Rows.propTypes = {
	customer: PropTypes.object.isRequired
};

export default PersonalDetails;
